import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DropZone } from 'foundations-components/transitional/components/DropZone';
import { Text } from 'foundations-components/components/Text';
import { EMPTY_PLACEHOLDER_ID_PARTIAL } from 'layout-dnd-utils/constants/dndAreaDomConstants';
import { getDndAreaElement } from 'layout-dnd-utils/grids/render/domSelectors';
// @ts-expect-error not typed yet
import AfterBeginPortal from 'ContentEditorUI/components/portals/AfterBeginPortal';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { getCurrentDropTarget, getDragItemIsHidden } from '../redux/selectors/layoutSectionDndSelectors';
import { getImmutableOrPlain } from 'ContentEditorUI/utils/dataHelpers';
import { getHasSectionsLibraryAccess } from 'ContentEditorUI/redux/selectors/sectionsSelectors';
import SectionsLibraryLayoutSectionEmptyState from './SectionsLibraryLayoutSectionEmptyState';
import { jsx as _jsx } from "react/jsx-runtime";
export default function GridEmptyTreePlaceholder({
  gridLayoutId
}) {
  const currentDropTarget = useSelector(state => getCurrentDropTarget(state));
  const dragItemIsHidden = useSelector(state => getDragItemIsHidden(state));
  const hasSectionsLibraryAccess = useSelector(getHasSectionsLibraryAccess);
  const gridLayoutElement = getDndAreaElement(gridLayoutId);
  const isHovered = !!currentDropTarget && !dragItemIsHidden && getImmutableOrPlain(currentDropTarget, 'gridLayoutId') === gridLayoutId;
  return /*#__PURE__*/_jsx(AfterBeginPortal, {
    id: `${EMPTY_PLACEHOLDER_ID_PARTIAL}-${gridLayoutId}`,
    namespace: NAMESPACE_CLASS,
    targetElement: gridLayoutElement,
    children: /*#__PURE__*/_jsx(DropZone, {
      size: "small",
      use: isHovered ? 'hover' : hasSectionsLibraryAccess ? 'selected' : 'default',
      marginBlock: "500",
      marginInline: "auto",
      inlineSize: "75%",
      "data-test-id": "grid-layout-empty-tree-drop-zone",
      children: hasSectionsLibraryAccess ? /*#__PURE__*/_jsx(SectionsLibraryLayoutSectionEmptyState, {
        gridLayoutId: gridLayoutId
      }) : /*#__PURE__*/_jsx(Text, {
        color: "icon-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.layoutSection.dropZone"
        })
      })
    })
  });
}